// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (max-width:48.0525em){.spacing--simple{height:calc(var(--spacing)*2)}.spacing--double{height:calc(var(--spacing)*4)}.spacing--triple{height:calc(var(--spacing)*6)}.spacing--none{height:0}}@media (min-width:48.0625em){.spacing--desktop--simple{height:calc(var(--spacing)*2)}.spacing--desktop--double{height:calc(var(--spacing)*4)}.spacing--desktop--triple{height:calc(var(--spacing)*6)}.spacing--desktop--none{height:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
